import App from 'src/components/App/App';
import UnauthApp from 'src/components/App/UnauthApp';

declare global {
  interface Window {
    App: any;
  }
}

export default App;

export { UnauthApp };
